import React, { useEffect, useState } from 'react';
import {withTranslation} from 'react-i18next';
import axios from 'axios';

const ProjectPurchaseorderTableComponent = ({ projectId, t }) => {
  const [purchaseTable, setPurchaseTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [projectCurrency, setProjectCurrency] = useState('HUF');

  const apiCall = (method, url, data) => {
    return axios({
      method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const formatCurrency = (value) => {
    return window.App.currencyFormatter(projectCurrency, value);
  };

  useEffect(() => {
    if (!projectId || projectId === 'undefined') {
      setPurchaseTable([]);
      return;
    }
    setLoading(true);
    apiCall('get', `/api/v2/purchase-order-supplier-item/summary/by-project/${projectId}`)
      .then(response => {
        setPurchaseTable(response?.data?.data?.items || []);
      })
      .catch(() => {
        setPurchaseTable([]);
      })
      .finally(() => {
        setLoading(false);
      });
    apiCall('get', '/api/v2/project/' + projectId)
      .then(response => {
        const currency = response?.data?.data?.currency || 'HUF';
        setProjectCurrency(currency);
      })
      .catch(() => {
        setProjectCurrency('HUF');
      });
  }, [projectId]);

  return (
    <div
      style={{
        position: 'relative',
        width: '520px',
        maxWidth: '100%',
        marginBottom: '1rem'
      }}
    >
    {!loading && purchaseTable.length === 0 ? (
      <p className="p-m-3">{t('noPurchasedMaterialsForProject')}</p>
    ) : (
      <div
        style={{
          border: '1px solid #ddd',
          borderRadius: '6px',
          overflow: 'hidden',
          background: '#fff',
          minHeight: '120px'
        }}
      >
        {loading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              zIndex: 5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(0, 0, 0, 0.18)',
              borderRadius: '6px'
            }}
          >
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
          </div>
        )}

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 160px 160px',
            background: '#f5f5f5',
            color: '#000',
            fontWeight: 600
          }}
        >
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd' }}>
            {t('material')}
          </div>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd' }}>
            {t('quantity')}
          </div>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #ddd' }}>
            {t('averagePurchasePrice')}
          </div>
        </div>

        {purchaseTable.map((item, i) => (
          <div
            key={i}
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 160px 160px',
              background: '#fff',
              color: '#000'
            }}
          >
            <div
              style={{
                padding: '12px 16px',
                borderBottom: i !== purchaseTable.length - 1 ? '1px solid #eee' : 'none',
                borderRight: '1px solid #eee'
              }}
            >
              {item.materialName}
            </div>
            <div
              style={{
                padding: '12px 16px',
                borderBottom: i !== purchaseTable.length - 1 ? '1px solid #eee' : 'none',
                borderRight: '1px solid #eee'
              }}
            >
              {item.orderedQuantity} {item.unitName}
            </div>
            <div
              style={{
                padding: '12px 16px',
                borderBottom: i !== purchaseTable.length - 1 ? '1px solid #eee' : 'none'
              }}
            >
              {formatCurrency(item.averageUnitPrice || 0)}
            </div>
          </div>
        ))}
      </div>
      )}
    </div>
  );
};

export default withTranslation('common')(ProjectPurchaseorderTableComponent);
